import React from 'react'
import Layout from './Layout';
import ApartmentLoginForm from './ApartmentLoginForm';
import ApartmentSmallScreen from './ApartmentSmallScreen';
import useResponsive from '../../shared/utils/Responsive';
const Login = () => {
    const isSmallScreen = useResponsive("md")
    return (
        <>
            {
                !isSmallScreen && (
                    <Layout text={"Apartment login to track activities and courses in your community."}>
                        <ApartmentLoginForm />
                    </Layout>
                )
            }
            {
                isSmallScreen && <ApartmentSmallScreen  tabPage={0}/>
            }

        </>

    )
}
export default Login

